import { postData } from './PostData';
import {global} from "./Global";

export const addToCart = () => {
	const addToCartElement = document.getElementsByClassName('add-to-cart-ajax');
	const miniCart = document.getElementById('mini-cart');
	const quickMenuQuantityInput = document.querySelector('.quick-menu [name="quantity"]');

	if (addToCartElement) {
		for (let i = 0; i < addToCartElement.length; i++) {
			addToCartElement[i].addEventListener('click', (e) => {
				e.preventDefault();
				let productId = e.currentTarget.dataset.id
				addToCart(productId);
			});
		}
	}

	window.singleProduct = () => {
		return {
			quantity: 1,
			updateQuantity(mode) {
				document.getElementById('loader').style.display = 'flex';

				if ('increase' === mode) {
					this.quantity += 1;
				}

				if ('decrease' === mode) {
					if (this.quantity > 1) {
						this.quantity -= 1;
					}
				}

				/**
				 * NOTE: This is only for quick-menu add to cart as we need quantity for GTM events
				 */
				if (quickMenuQuantityInput) {
					quickMenuQuantityInput.value = this.quantity;
				}

				document.getElementById('loader').style.display = 'none';
			},
			addToCart(productId) {
				addToCart(productId, this.quantity);
			},
			init() {
				this.quantity = 1;
			}
		}
	}

	function addToCart(productId, quantity = 1) {
		document.getElementById('loader').style.display = 'flex';

		const form = new FormData();

		form.append('action', 'cl_add_to_cart');
		form.append('product_id', productId);
		form.append('quantity', quantity);
		form.append('_ajax_nonce', my_ajax_object.nonce);
		form.append('blocksToUpdate', global.getBlocksToUpdate());

		const params = new URLSearchParams(form);

		postData(my_ajax_object.ajax_url, params)
			.then(response => {
				document.getElementById('loader').style.display = 'none';

				if (!response || response.error) {
					return;
				}

				global.updateBlocks(response);

				miniCart.style.display = 'flex';
				document.body.style.overflow = 'hidden';
			});
	}
}
